<template>
  <div class="row">
    <!--  权限列表  -->
    <div class="flex xs12">
      <va-card title="权限列表">
        <div class="row align-center mb-1">
          <div class="flex md12 xs12 sm6">
            <va-button-group>
              <va-button flat outline disabled color="gray">业务类型:</va-button>
              <va-button flat outline color="gray"
                :color="handleColorChange(null)"
                v-on:click="handleBusinessChange(null)"
              >全部</va-button>

              <va-button flat outline v-for="business in businesses" :key="business.id"
                :color="handleColorChange(business.id)"
                v-on:click="handleBusinessChange(business.id)"
              >{{business.displayName}}</va-button>
            </va-button-group>
          </div>
          <div class="flex md6 xs12 sm12">
            <va-button class="mb-2" flat disabled color="danger">总计{{totalCount}}条结果</va-button>
          </div>
          <div class="flex md6 xs12 sm12">
            <div class="d-flex justify--end">
              <va-button color="info" small :to="{ name: 'savePermission' }">新增权限</va-button>
            </div>
          </div>
        </div>
        <va-data-table
          :fields="fields"
          :data="permissions"
          :loading="loading"
          :totalPages="totalPages"
          @page-selected="listPermission"
          api-mode
        >
          <template slot="sort" slot-scope="props">
            <va-input
              v-model="props.rowData.sortNum"
              type="number"
              :min="1"
              v-bind:style="{width: '50%', margin: '1rem auto'}"
              oninput="if(value<0)value=1"
            >
              <va-button slot="append" icon="ion-md-checkmark ion" color="info" small @click="updateSortNum(props.rowData)">
              </va-button>
            </va-input>
          </template>
          <template slot="actions" slot-scope="props">
            <va-button flat small color="gray" icon="fa fa-trash"
              @click="deleteModal = true;deleteId=props.rowData.id"/>
          </template>
        </va-data-table>
        <va-modal
          v-model="deleteModal"
          title="删除权限"
          okText="提交"
          position="center"
          message="请再次确认是否要删除？"
          @ok="confirmDelete"
        />

      </va-card>
    </div>
  </div>
</template>

<script>
import permissionApi from '../../api/permission'
import debounce from 'lodash/debounce'
import businessApi from '../../api/business'
export default {
  data () {
    return {
      message: ['Required field'],
      // serviceId: 3,
      permissions: [],
      loading: true,
      deleteModal: false,
      pageNumber: 1,
      totalCount: 0,
      pageSize: 10,
      totalPages: 1,
      businessName: '',
      businessId: null,
      businesses: [],
      deleteId: null,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:sort',
          title: '排序',
          width: '16%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'displayName',
          title: '权限名称',
          width: '16%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'businessName',
          title: '业务代码',
          width: '16%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'action',
          title: 'action代码',
          width: '16%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'description',
          title: '描述',
          width: '16%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:actions',
          title: '操作',
          width: '16%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    },
  },
  created () {
    this.listBusiness()
    this.listPermission()
  },
  methods: {
    listPermission (pageNumber = this.pageNumber) {
      this.loading = true
      const params = {
        pageNumber: pageNumber,
        pageSize: this.pageSize,
        businessId: this.businessId,
      }
      permissionApi.listAllPermissions(params).then(response => {
        this.permissions = response.permissions
        this.loading = false
        this.pageNumber = pageNumber
        this.totalCount = response.pages.totalCount
        this.totalPages = response.pages.totalPage
      }).catch(error => alert(error))
    },
    listBusiness () {
      this.loading = true
      const params = {}
      businessApi.listBusiness(params).then(response => {
        this.businesses = response.businesses
        this.loading = false
      }).catch(error => { alert(error.msg) })
    },
    confirmDelete () {
      if (this.deleteId === null) return
      permissionApi.deletePermission(this.deleteId).then(response => {
        if (response.success === true) {
          this.showToast('删除权限成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.listPermission()
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    updateSortNum: function (params) {
      if (params.sortNum === null) {
        return
      }
      const data = {
        sortNum: params.sortNum,
      }
      permissionApi.updatePermissionSortNum(params.id, data).then(response => {
        if (response.success === true) {
          this.showToast('更新排序成功', {
            duration: 1000,
            icon: 'fa-success',
            position: 'top-center',
            fullWidth: false,
          })
          this.listPermission()
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    handleBusinessChange (businessId) {
      this.businessId = businessId
      this.pageNumber = 1
      this.listPermission()
    },
    handleColorChange (businessId) {
      return this.businessId === businessId ? 'info' : 'gray'
    },
  },
}

</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
</style>
